export default "__VITE_ASSET__zIGHRT9u__"